import React, { useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { SERVICE_TYPE_PATH } from "../../../../config/paths";
import { breadcrumbsPropTypes, matchPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Content from "../../../layout/Content";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import InternalResource from '../../../common/resource/InternalResource';
import ServiceTypeBasicInformationResource from "./resources/ServiceTypeBasicInformationResource";
import ServiceTypeToolbar from "./ServiceTypeToolbar";
import { clearServiceType, getServiceType } from "../../../../actions";

export const ServiceType = ({
    breadcrumbs,
  dispatchGetServiceType,
  dispatchClearServiceType,
  match: {
    params: { id: serviceTypeId },
  },
  loading,
  serviceType,
}) => {
  useLayoutEffect(() => {
    dispatchGetServiceType({ serviceTypeId });

    return () => dispatchClearServiceType();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (serviceType.isEmpty())
    content = <NoDataResource returnPage={SERVICE_TYPE_PATH} />;
  else {
    const serviceTypeJson = serviceType.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <ServiceTypeBasicInformationResource {...serviceTypeJson} />
        <InternalResource id={serviceTypeJson.id}
          createDate={serviceTypeJson.createDate}
          lastUpdate={serviceTypeJson.lastUpdate}/>
      </>
    );

    toolbar = <ServiceTypeToolbar serviceTypeId={serviceTypeJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Tipos de Servicio"
      content={content}
    />
  );
};

ServiceType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearServiceType: PropTypes.func.isRequired,
  dispatchGetServiceType: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  serviceType: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ServiceType.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearServiceType: clearServiceType,
  dispatchGetServiceType: getServiceType
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Servicio',
      href: SERVICE_TYPE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  serviceType: BusUnit.ServiceType.getIn(['current', 'content']),
  loading: !BusUnit.ServiceType.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceType);